import { gate as v3Gate } from 'hub-http/gates';
import { userInfoSync } from 'hub-http/userInfo';
import PortalIdParser from 'PortalIdParser';
export const SETTINGS_ROUTER_GATE = v3Gate('ConnectedApps::SettingsRouter');
export const getAppSettingsUrl = ({
  appId,
  portalId
}) => {
  if (userInfoSync().gates.includes(SETTINGS_ROUTER_GATE)) {
    return `/integration/${portalId !== null && portalId !== void 0 ? portalId : PortalIdParser.get()}/settings/${appId}`;
  }
  return `/integrations-settings/${portalId !== null && portalId !== void 0 ? portalId : PortalIdParser.get()}/installed/application/${appId}`;
};